import { styled } from "@mui/material/styles";

const EllipsisRoot = styled("div")(({ theme }) => ({
  marginLeft: theme.spacing(0.5),
  height: theme.spacing(1),
  display: "inline-flex",
  alignItems: "center",
  "& > span": {
    marginRight: theme.spacing(0.5),
    width: theme.spacing(1),
    height: theme.spacing(1),
    borderRadius: "50%",
    backgroundColor: theme.palette.primary.main,
    animation: `ellipsisCycle 500ms linear alternate infinite`,
    "&:nth-child(1)": {
      animationDelay: `-333.5ms`,
    },
    "&:nth-child(2)": {
      animationDelay: `-167ms`,
    },
  },
  "@keyframes ellipsisCycle": {
    "0%, 33.3%": {
      opacity: 0.38,
    },
    "50%": {
      opacity: 0.6,
    },
    "66.7%, 100%": {
      opacity: 1,
    },
  },
}));

function Ellipsis() {
  return (
    <EllipsisRoot>
      <span />
      <span />
      <span />
    </EllipsisRoot>
  );
}

export default Ellipsis;
